export const GLOBAL_SKILL_SEARCH_ALIASES: Readonly<
  Record<string, readonly string[]>
> = {
  "go-deep": ["Deep Dive"],
  frames: ["MiniApps", "Frames", "MiniApp"],
  sandbox: ["Sandbox"], // Currently called "Computer", but makes sense to think of it as a sandbox.
};
